// extracted by mini-css-extract-plugin
export default {"share":"XByGK","button":"H5RWw","menu":"CZOzW","options":"eK7QY","option":"iQIyk","shareIcons":"z2MiI"};